// # #############################################
// # Title : Market Share Pie Chart
// # Authors : Sameer, Dhruv, Mahesh, Shubham
// # Date : 15th October 2019
// # Last Modified : Dhruv, August 2019
// # Version : 19.10.03
// # Description : This is the code for the pie chart which shows the market share on the simulation summary tab
// # ############################################

// Import Required Libraries

import React, { Component } from "react";
import Highcharts from "highcharts";

class PieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data
    };
  }
  componentDidMount() {
    // Function to Load the Chart

    this.loadWindroseChart(this.props.data);
  }

  componentDidUpdate() {
    // Function to Load the Chart

    this.loadWindroseChart(this.props.data);
  }

  loadWindroseChart(input) {
    let temp2 = []

    if (input && input.data && input.data.length > 0) {
      temp2 = input.data.filter(data => data.name !== "Your Brand").sort((a, b) => (a.name > b.name) ? 1 : -1)
      input.data = [input.data.filter(data => data.name === "Your Brand")[0], ...temp2]
    }


    // Options for the Pie Chart (Visit HighCharts Documentation for more information)
    Highcharts.chart(this.refs.pies, {
      chart: {
        backgroundColor: "whitesmoke",
        plotBackgroundColor: "whitesmoke",
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        animation: false
      },
      title: {
        text: "Market share based on units sold"
      },
      tooltip: {},

      colors: ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"],

      credits: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: false
        },
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            style: {
              color:
                (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                "black"
            }
          }
        }
      },

      series: [input]
    });
  }

  render() {
    // Self Explanatory
    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          paddingTop: "20px",
          // minWidth: "240px",
          //maxWidth: "500px",
          margin: "0 auto",
          height: "300px"
        }}
        ref="pies"
      />
    );
  }
}

export default PieChart;
